import React from "react";

function Home() {
  return (
    <div className="home">
      <section id="about" className="section about-us">
        <div className="about-text">
          <h1>Welcome to Iryna Laser Glow</h1>
          <p>Your trusted partner in achieving smooth, hair-free skin through advanced laser hair removal treatments.</p>
          <p>
            🌟 Experience safe, painless, and effective treatments tailored specifically to your unique needs.
          </p>
          <p>
            ✨ Schedule a <strong>FREE consultation</strong> today and discover the transformative benefits of laser hair removal!
          </p>
          <p>🌟 Certified Laser Hair Removal Therapist 🇬🇧</p>
          <p>🌟 VTCT Qualified in the UK: Level 2, 3, and 4</p>
          <p>🌟 Committed to Pain-Free & Safe Treatments</p>
          <p>🌟 Medical Background from Ukraine 🇺🇦</p>
          <p>🌟 Conveniently located in Woodford IG8</p>
        
          <h3>💥 Why Choose Iryna Laser Glow?</h3>
          <ul>
            <li>✅ Personalized care tailored to your individual needs</li>
            <li>✅ Quick and comfortable treatment sessions</li>
            <li>✅ Affordable packages with special offers for first-time clients</li>
            <li>✅ Results that will leave you feeling confident and beautiful</li>
          </ul>
          <p>
            🌟 Are you ready to say goodbye to razors and waxing for good? Book your <strong>FREE consultation</strong> now and enjoy an exclusive discount on your first session!
          </p>
        </div>
        <img src="/image/Iryna.jpg" alt="Iryna, the laser therapist" className="about-image" />
      </section>
    </div>
  );
}

export default Home;
